import React, { useEffect, useRef, useState } from 'react';

export const StreamLineScroll = ({ cardData, images }) => {
    const leftRefs = useRef([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const stackRef = useRef(null);
    const rotateCardsRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        setActiveIndex(0);
    }, []);

    useEffect(() => {
        if (!stackRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
            },
            {
                threshold: 0.2, // 20% visible = in view
            }
        );

        observer.observe(stackRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const cards = document.querySelectorAll('.card');
        const stackArea = document.querySelector('.stack-area');

        function rotateCards(activeIndex) {
            let angle = 0;
            let rotate = 50;

            cards.forEach((card, i) => {
                if (i < activeIndex) {
                    card.style.opacity = 0;
                    card.style.transform = 'translate(-50%, -120vh) rotate(-48deg)';
                } else {
                    card.style.opacity = 1;
                    card.style.transform = `translate(-${rotate}%, -${rotate}%) rotate(${angle}deg)`;
                    angle += 3;
                    rotate -= 3;
                }
            });
        }

        rotateCardsRef.current = rotateCards;
        rotateCards(0);

        const handleScroll = () => {
            const stackArea = document.querySelector('.stack-area');
            const cards = document.querySelectorAll('.card');

            const rect = stackArea.getBoundingClientRect();
            const progress = Math.min(Math.max(-rect.top / window.innerHeight, 0), 1);

            const n = cards.length;
            const index = Math.floor(progress * n);

            cards.forEach((card, i) => {
                if (i < index) {
                    card.classList.add('active');
                } else {
                    card.classList.remove('active');
                }
            });

            setActiveIndex(index);
            rotateCards(index);
        };
        const handleResize = () => {
            const windowWidth = window.innerWidth;
            const left = document.querySelector('.left');
            if (left) {
                left.remove();
                if (windowWidth < 800) {
                    stackArea.insertAdjacentElement('beforebegin', left);
                } else {
                    stackArea.insertAdjacentElement('afterbegin', left);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const styles = {
        center: {
            width: '100%',
            height: 'fit-content',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        stackArea: {
            width: '100%',
            height: '220vh',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            // marginTop: '-150px',
        },
        left: {
            height: '90vh',
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: isInView ? 'flex-start' : 'center',
            position: 'sticky',
            top: 0,
            flexDirection: 'column',
            flexBasis: '50%',
        },
        right: {
            height: '90vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            boxSizing: 'border-box',
            position: 'sticky',
            top: 0,
            flexBasis: '50%',
        },
        card: {
            backgroundColor: 'white',
            width: '594px',
            height: '435px',
            boxSizing: 'border-box',
            padding: '0',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            position: 'absolute',
            top: isInView ? '35%' : '50%',
            left: '50%',
            transition: '0.5s ease-in-out',
            borderRadius: '24px',
            border: '8px solid #EEF5FE',
            boxShadow: '0 25px 50px -12px rgba(30, 58, 138, 0.20)',
        },
    };

    return (
        <div className="container">
            <div ref={stackRef} style={{ height: 1 }} />

            <div style={styles.center}>
                <div style={styles.stackArea} className="stack-area">
                    <div style={styles.left} className="left">
                        <div className="complate-aba-care-slide-content">
                            {cardData?.map((item, index) => (
                                <div
                                    onClick={() => {
                                        setActiveIndex(index);
                                        if (rotateCardsRef.current) {
                                            rotateCardsRef.current(index);
                                        }
                                    }}
                                    key={index}
                                    ref={(el) => (leftRefs.current[index] = el)}
                                    className="complate-aba-care-slide-content-item-wrapper"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div
                                        style={{ backgroundColor: activeIndex === index ? '#1668E8' : '#EEF5FE' }}
                                        className="complate-aba-care-slide-content-item-step"
                                    />

                                    <div className="complate-aba-care-slide-content-item-block">
                                        <h4
                                            style={{
                                                color: activeIndex === index ? '#1668E8' : '#475467',
                                                fontWeight: activeIndex === index ? 700 : 500,
                                            }}
                                            className="complate-aba-care-slide-content-item-title"
                                        >
                                            {item.title}
                                        </h4>

                                        <p className="complate-aba-care-slide-content-item-text">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/*{activeIndex > images?.length ? }*/}
                    <div style={styles.right} className="right">
                        <div className="cards">
                            {images.map((item, index) => (
                                <div
                                    key={index}
                                    className="card"
                                    style={{
                                        ...styles.card,
                                        zIndex: cardData.length - index,
                                    }}
                                >
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'fill',
                                            borderRadius: '12px',
                                        }}
                                        // style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        src={item?.image}
                                        alt="image"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
